import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#F0F0F0",
  d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#0052B4",
  d: "M2.481 4.693A12 12 0 0 0 .414 8.87h6.243zM23.586 8.869a12 12 0 0 0-2.067-4.176L17.344 8.87zM.414 15.13a12 12 0 0 0 2.067 4.176l4.176-4.176zM19.304 2.48A12 12 0 0 0 15.13.413v6.242zM4.695 21.518a12 12 0 0 0 4.176 2.067v-6.242zM8.87.413A12 12 0 0 0 4.696 2.48l4.176 4.175zM15.129 23.585a12 12 0 0 0 4.175-2.067l-4.175-4.175zM17.344 15.13l4.175 4.176a12 12 0 0 0 2.067-4.176z"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#D80027",
  d: "M23.898 10.435H13.565V.102a12.1 12.1 0 0 0-3.13 0v10.333H.102a12.1 12.1 0 0 0 0 3.13h10.333v10.333a12.1 12.1 0 0 0 3.13 0V13.565h10.333a12.1 12.1 0 0 0 0-3.13"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#D80027",
  d: "m15.129 15.131 5.355 5.355q.368-.37.705-.77l-4.584-4.585zM8.87 15.131l-5.354 5.355q.37.369.77.705l4.584-4.584zM8.869 8.87 3.514 3.514q-.369.37-.705.77L7.393 8.87zM15.129 8.87l5.355-5.355a12 12 0 0 0-.77-.705l-4.585 4.585z"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_6]))
}
export default { render: render }